document.addEventListener("DOMContentLoaded", function() {
  function handleMobileFooterLinkToggle() {
    if (window.innerWidth <= 768) {
      // Close all other panels
      document.querySelectorAll('.footer-block__heading').forEach(heading => {
        if (heading !== this) {
          heading.classList.remove('active');
          let otherContent = heading.nextElementSibling;
          if (otherContent.style.maxHeight !== '0px') {
            otherContent.style.maxHeight = '0px';
          }
        }
      });
  
      // Toggle the current panel
      let detailsContent = this.nextElementSibling;
      if (this.classList.contains('active')) {
        this.classList.remove('active');
        detailsContent.style.maxHeight = '0px'; // Start the collapsing transition
      } else {
        this.classList.add('active');
        // Set max height to actual scrollHeight plus a little extra space
        detailsContent.style.maxHeight = detailsContent.scrollHeight + "px"; // Expand the panel
      }
    }
  }
  
  const header = document.querySelector('.shopify-section-header-sticky');
  if (!header) return;

  let isSticky = false;

  function checkSticky() {
    const headerRect = header.getBoundingClientRect();
    // Only add "is-sticky" class when scrolled at least 5px
    if (window.scrollY > 5 && !isSticky) {
        header.classList.add('is-sticky');
        isSticky = true;
    } else if (window.scrollY <= 5 && isSticky) {
        header.classList.remove('is-sticky');
        isSticky = false;
    }
  }

  // Run check on scroll
  window.addEventListener('scroll', checkSticky);

  // Run check on page load (in case user reloads while scrolled down)
  checkSticky();

  // Event listener setup
  document.querySelectorAll('.footer-block__heading').forEach(function(heading) {
    heading.addEventListener('click', handleMobileFooterLinkToggle);
  });

  const spinElements = document.querySelectorAll('[image-spin]');
  const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              entry.target.style.transition = 'transform 1s';
              entry.target.style.transform = 'rotate(360deg)';
              observer.unobserve(entry.target); // Stop observing after animation
          }
      });
  }, { threshold: 0.5 }); // Adjust threshold as needed

  spinElements.forEach(el => {
      observer.observe(el);
  });

  const currentHost = window.location.host;
  document.querySelectorAll('a[href^="http"]').forEach(link => {
    try {
      const url = new URL(link.href);
      // if destination host is different, treat as external
      if (url.host !== currentHost) {
        link.setAttribute('target', '_blank');
        link.setAttribute('rel', 'noopener noreferrer');
      }
    } catch(e) {
      // malformed URL? ignore
    }
  });

  const sliders = document.querySelectorAll('.slideshow .slider');
  
  sliders.forEach(slider => {
    let resizeTimeout;
    
    function realignSlides() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        // Get the currently active slide
        const slideshowComponent = slider.closest('slideshow-component');
        const currentSlideIndex = slideshowComponent ? 
          parseInt(slideshowComponent.querySelector('.slider-counter--current')?.textContent || '1') - 1 : 0;
        
        const slides = slider.querySelectorAll('.slideshow__slide');
        const targetSlide = slides[currentSlideIndex] || slides[0];
        
        if (targetSlide) {
          // Force immediate alignment without animation
          slider.style.scrollBehavior = 'auto';
          targetSlide.scrollIntoView({
            behavior: 'auto',
            block: 'nearest',
            inline: 'center'
          });
          
          // Re-enable smooth scrolling after alignment
          setTimeout(() => {
            slider.style.scrollBehavior = 'smooth';
          }, 100);
        }
      }, 200);
    }
    
    // Handle both resize and orientation change
    window.addEventListener('resize', realignSlides);
    window.addEventListener('orientationchange', function() {
      // Orientation change needs a longer delay
      setTimeout(realignSlides, 300);
    });
  });
});
